'use client'

import { useAuth } from '@/lib/auth-context'
import { RealtimeProvider } from './realtime-provider'

interface RealtimeProviderWrapperProps {
  children: React.ReactNode
}

export function RealtimeProviderWrapper({ children }: RealtimeProviderWrapperProps) {
  const { isAuthenticated } = useAuth()

  return (
    <RealtimeProvider isAuthenticated={isAuthenticated}>
      {children}
    </RealtimeProvider>
  )
}
